import { cn } from "@/lib/cn";
import Eyebrow from "./Eyebrow";
import Reveal from "./Reveal";

interface SectionHeadingProps {
  kicker: string;
  index?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: "center" | "left";
  className?: string;
  /** Nível do heading (h2 por padrão; a página deve ter um único h1) */
  as?: "h1" | "h2";
}

export default function SectionHeading({
  kicker,
  index,
  title,
  description,
  align = "center",
  className,
  as: Tag = "h2",
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      <Reveal>
        <Eyebrow index={index}>{kicker}</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <Tag className="h-display mt-5 text-[clamp(2rem,5.2vw,3.6rem)] text-fg">
          {title}
        </Tag>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p className="mt-5 text-pretty text-base leading-relaxed text-muted sm:text-lg">
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
